class SplideSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const options = {
            gap: '10px',
            perPage: 5,
            perMove: 1,
            pagination: false,
            arrows: true,
            destroy: false,
            mediaQuery: 'max'
        }
        if (this.dataset.destroy) options.destroy = this.dataset.destroy === 'true'
        if (this.dataset.type) options.type = this.dataset.type
        if (this.dataset.role) options.role = this.dataset.role
        if (this.dataset.label) options.label = this.dataset.label
        if (this.dataset.gap) options.gap = this.dataset.gap
        if (this.dataset.autoWidth) options.autoWidth = this.dataset.autoWidth
        if (this.dataset.autoHeight) options.autoHeight = this.dataset.autoHeight
        if (this.dataset.perPage) options.perPage = parseInt(this.dataset.perPage)
        if (this.dataset.perMove) options.perMove = parseInt(this.dataset.perMove)
        if (this.dataset.pagination) options.pagination = this.dataset.pagination === 'true'
        if (this.dataset.padding) {
            if (this.dataset.padding.includes('{')) {
                options.padding = JSON.parse(this.dataset.padding)
            } else {
                options.padding = this.dataset.padding
            }
        }
        if (this.dataset.arrows) options.arrows = this.dataset.arrows === 'true'
        if (this.dataset.mediaQuery) options.mediaQuery = this.dataset.mediaQuery
        if (this.dataset.destroy) options.destroy = this.dataset.destroy === 'true' ? true : this.dataset.destroy
        if (this.dataset.breakpoints) options.breakpoints = JSON.parse(this.dataset.breakpoints)

        new Splide(this, options).mount();
    }
}

customElements.define('splide-slider', SplideSlider)


class SimpleVideo extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.video = this.querySelector('video')
        if (this.video.getAttribute('controls') === 'controls') {
            this.insertPlayButton()
            this.video.addEventListener('play', () => {
                this.classList.add('playing')
            })
            this.video.addEventListener('pause', () => {
                this.classList.remove('playing')
            })
        }
    }

    insertPlayButton () {
        const button = document.createElement('div')
        button.classList.add('play-button')
        this.appendChild(button)

        const icon = document.createElement('span')
        icon.classList.add('play-icon')
        button.appendChild(icon)

        button.addEventListener('click', () => {
            this.video.play()
        })

        return button
    }
}
customElements.define('simple-video', SimpleVideo)